// @ts-nocheck 643fa210
import * as actions from './permanentBorderActions';
import reducer from './permanentBorderReducer';
import * as selectors from './permanentBorderSelectors';

export { actions, reducer, selectors };
